/**
 * LiveFlight Checkout Module
 * Handles traveler details, contact information, and guest data
 */

/**
 * Checkout state properties
 */
export const state = {
  traveler_details: [],
  contact_details: {},
  guests: {},
};

/**
 * Custom mutations for checkout state
 * Note: Basic mutations (setter for each property) are auto-generated by vuex_store_config
 */
export const mutations = {};

/**
 * Keys to persist in local storage
 */
export const localStorageKeys = [
  "traveler_details",
  "contact_details",
];
